import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InstrumentReagent } from './../../models/instrument_reagent';
import { LaboratoryService } from './../../services/laboratory.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-add-reagent-dialog',
  templateUrl: './add-reagent-dialog.component.html',
  styleUrls: ['./add-reagent-dialog.component.css']
})
export class AddReagentDialogComponent implements OnInit {
	@Input() instrument;
	@Input() manufacturers;
	@Output() result: EventEmitter<any> = new EventEmitter();
	reagent:InstrumentReagent;
	manufacturer:any = {id:null,name:''};
	newManufacturer = false;
	message:string;
	messageClass:string;
	
	constructor(public activeModal: NgbActiveModal,private lService:LaboratoryService,private spinnerService: Ng4LoadingSpinnerService) { }
	
	ngOnInit() {
		this.reagent = {};
		console.log(this.manufacturers);
	}

	saveReagent(){
		
		if(confirm('Are you sure?')){
			this.spinnerService.show();
			let rgnt = {
				name:this.reagent.name,
				instrument_id:this.instrument.id,
				manufacturer_id:null,
				manufacturer_name:null
			};
			if(this.newManufacturer)
				rgnt.manufacturer_name = this.manufacturer.name;
			else
				rgnt.manufacturer_id = this.manufacturer.id;
			this.lService.addNewReagent(rgnt).subscribe(
				data => {
					var jsonData = <any>data;
					if(jsonData.hasOwnProperty('result') && jsonData.result){
						this.messageClass = "alert alert-primary";
						let datum = {manufacturer:null,reagent:null};
						if(jsonData.hasOwnProperty('manufacturer')){
							datum.manufacturer = jsonData.manufacturer;
						}
						if(jsonData.hasOwnProperty('reagent')){
							datum.reagent = jsonData.reagent;
						}
						this.result.emit(datum);
						this.activeModal.dismiss();
						
					}else{
						this.messageClass = "alert alert-danger";
					}
					if(jsonData.hasOwnProperty('message')){
						this.message = jsonData.message;
					}
					
					
					this.spinnerService.hide();
				},
				error => {
					var jsonData = <any>error;
					this.messageClass = "alert alert-danger";
					if(jsonData.hasOwnProperty('message')){
						this.message = jsonData.message;
					}
					this.spinnerService.hide();
				}
			);
		}
	
	}

}
